import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';

import TextField from '@material-ui/core/TextField';
import CustomAutocomplete from "../CustomAutocomplete";
import { createFilterOptions } from '@material-ui/lab/Autocomplete';

import Troops from './Troops';

import GroupMembers from './GroupsMembers';
import DeptMembers from './DeptMembers';

class GroupDetail extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();

        var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
        var localdata = has_local_data
            ? this.decrypt(localStorage.getItem("encdata"), 0)
            : "";

        this.state = {
            userAuthKey: has_local_data ? localdata.user_key : "",
            apiUrl: this.decryptconfigdata("apiUrl"),
            userId: has_local_data ? localdata.user_id : "",
            user_Name: has_local_data ? localdata.user_name : "",

            groups: [],
            group_types: [],
            group_members: [],
            emailgroup_members: [],
            group_pods: [],
            defaultList: [],
            selected_primary: [],
            selected_lister: [],

            hr_permission: 'no',
            manager_permission: 'no',

            waiting: '',
            errors: {},
            formData: {},
            group_data: {},
            memberData: {},
            memberRestriction: {},
            group_details: { 'primary': [], 'listener': [] },
            success_message: '',
            is_editable: false,
            success_popup_msg: "",
            log_activity: [],
            deleteGroupData: {},
            loading: false,
            deleteEmpData: {},
            removeConfirmMsg: "",
            desctextlen: 500,
        };

    }
    showDeleteModal(group_id, grp_name, member_cnt) {
        var groupData = this.state.deleteGroupData;
        groupData['group_id'] = group_id;
        groupData['grp_name'] = grp_name;
        groupData['member_cnt'] = member_cnt;
        this.setState({ deleteGroupData: groupData });
    }
    showRemoveEmployeeModal(group_id, group_name, member_name, is_primary, member_id, group_type) {
        //        alert(group_name+"=="+member_name);return false;
        var empData = this.state.deleteEmpData;
        empData['group_id'] = group_id;
        empData['is_primary'] = is_primary;
        empData['member_id'] = member_id;
        empData['group_type'] = group_type;
        empData['group_name'] = group_name;
        empData['member_name'] = member_name;
        var removeConfirmMsg = "";
        if (group_type == 3) {
            removeConfirmMsg = "Are you sure to remove the pod " + member_name + " from the group " + group_name + " ?";
        } else {
            removeConfirmMsg = "Are you sure to remove this employee " + member_name + " from the group " + group_name + "?";
        }
        this.setState({ deleteEmpData: empData, removeConfirmMsg });
    }
    deleteGroup(group_id, grp_name, member_cnt) {
        var groupData = {};
        groupData['userId'] = this.state.userId;
        groupData['id'] = group_id;
        fetch(this.state.apiUrl + '/HrmanagementRest/DeleteGroup' + '/userAuthKey/' + this.state.userAuthKey, {
            method: "POST",
            dataType: "json",
            body: JSON.stringify(groupData)
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                console.log(201, findresponse)
                window.location.href = '/groups/';
            })
    }

    removeEmployeeFromGroup(group_id, is_primary, member_id, group_type) {
        var groupType = (group_type == 3) ? "Pod deleted successfully from group" : "Member deleted successfully from group";
        fetch(this.state.apiUrl + '/HrmanagementRest/DeleteMemberFromGroup/userId/' + this.state.userId + '/member_id/' + member_id + '/is_primary/' + is_primary + '/group_id/' + group_id + '/userAuthKey/' + this.state.userAuthKey, {
            method: "POST",
            dataType: "json"
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    window.$("#deleteEmployee").modal('hide');
                    this.setState({
                        success_popup_msg: groupType
                    });
                    console.log(115, this.state.success_popup_msg);
                    if (this.timer) {
                        window.clearTimeout(this.timer);
                    }
                    window.$("#quiz_Pass").modal('show');
                    this.timer = window.setTimeout(function () {
                        window.$("#quiz_Pass").modal('hide');
                    }, 1500);
                    this.GetGroupDetails(this.props.match.params.groupId);
                    this.logActivity(this.props.match.params.groupId);
                }
            });
    }
    AddPod() {
        this.setState({ waiting: 'loading' });
        let formData = this.state.formData;
        formData['selected_pod'] = this.state.memberData.selected_pod_includes;
        let is_valid = this.handleMemberValidation(formData['group_type']);
        if (!is_valid) {
            this.setState({ waiting: '' });
            return false;
        }
        let api_url = this.state.apiUrl + '/HrmanagementRest/AddMember/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey;

        console.log(103, this.state.memberData);
        console.log(103, formData);
        fetch(api_url, {
            method: 'POST',
            dataType: "json",
            body: JSON.stringify(formData),
        }).then((Response) => Response.json())
            .then((findresponse) => {
                window.$("#addMember").modal('hide');
                this.setState({ waiting: '', success_popup_msg: "Pod added successfully", formData: { 'pod_includes': [] } });
                window.$("#quiz_Pass").modal('show');
                if (this.timer) {
                    window.clearTimeout(this.timer);
                }
                this.timer = window.setTimeout(function () {
                    window.$("#quiz_Pass").modal('hide');
                }, 1500);
                this.GetGroupDetails(this.props.match.params.groupId);
                this.logActivity(this.props.match.params.groupId);
            })
    }
    AddMember() {
        let formData = this.state.formData;
        formData['selected_members'] = this.state.memberData.selected_members;
        let api_url = this.state.apiUrl + '/HrmanagementRest/AddMember/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey;
        console.log(122, this.state.memberData);
        console.log(122, formData);
        this.setState({ waiting: 'loading' });
        let is_valid = this.handleMemberValidation(formData['group_type']);
        if (!is_valid) {
            this.setState({ waiting: '' });
            return false;
        }
        fetch(api_url, {
            method: 'POST',
            dataType: "json",
            body: JSON.stringify(formData),
        }).then((Response) => Response.json())
            .then((findresponse) => {
                window.$("#addMember").modal('hide');
                window.$("#quiz_Pass").modal('show');
                this.setState({ waiting: '', success_popup_msg: "Member added successfully", formData: { 'selected_members': [] } });
                if (this.timer) {
                    window.clearTimeout(this.timer);
                }
                this.timer = window.setTimeout(function () {
                    window.$("#quiz_Pass").modal('hide');
                }, 1500);
                this.GetGroupDetails(this.props.match.params.groupId);
                this.logActivity(this.props.match.params.groupId);
            })
    }

    AddPrimarynListenerMember() {
        this.setState({ waiting: 'loading' });
        let formData = this.state.formData;
        formData['primary_members'] = this.state.memberData.selected_primary_members;
        formData['listener_members'] = this.state.memberData.selected_listener_members;
        let is_valid = this.handleMemberValidation(formData['group_type']);
        console.log(172, is_valid);
        console.log(172, formData);
        //        console.log(172,this.state.memberData);
        //        return false;
        if (!is_valid) {
            this.setState({ waiting: '' });
            return false;
        }

        let api_url = this.state.apiUrl + '/HrmanagementRest/AddMember/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey;
        //        console.log(77,this.state.memberData);return false;
        fetch(api_url, {
            method: 'POST',
            dataType: "json",
            body: JSON.stringify(formData),
        }).then((Response) => Response.json())
            .then((findresponse) => {
                window.$("#addMember").modal('hide');
                window.$("#quiz_Pass").modal('show');
                if (this.timer) {
                    window.clearTimeout(this.timer);
                }
                this.timer = window.setTimeout(function () {
                    window.$("#quiz_Pass").modal('hide');
                }, 1500);
                this.setState({ waiting: '', success_popup_msg: "Member added successfully", formData: { 'listener_members': [], 'primary_members': [] } });
                this.GetGroupDetails(this.props.match.params.groupId);
                this.logActivity(this.props.match.params.groupId);

            }).catch(function (error) {
                //          errors['form'] = error;
                //          console.log(error);
            });
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
        var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv,
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
        var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv,
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    toggleEdit() {
        var exist_desc_len = this.state.formData['description'] ? this.state.formData['description'].length : 0;
        var maxLength = 500;
        var remain_character = maxLength - exist_desc_len;
        this.setState({ desctextlen: remain_character });
        this.setState(({ is_editable }) => ({ is_editable: !is_editable }));
        this.setState({
            waiting: '',
            errors: {},
        });
    }

    ResetForm() {
        window.history.back();
        //window.parent.location = window.parent.location.href;
    }

    onChangeFrom(type, e) {
        console.log(e);
        var formData = this.state.formData;

        var errors = this.state.errors;

        formData[type] = e.target.value;

        errors[type] = '';

        this.setState({
            formData: formData,
            errors: errors,
        });
    }

    handleValidation() {

        let formData = this.state.formData;
        let errors = {};
        let formIsValid = true;

        var regName = /^[a-z\d\-_\s]+$/i;

        var regEmail = /@muvi.com\s*$/;

        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;


        if (!formData["name"] || !formData["name"].trim()) {
            formIsValid = false;
            errors["name"] = "Please enter group name";
        } else if (!regName.test(formData["name"])) {
            formIsValid = false;
            errors["name"] = "Please enter a valid group name";
        } else if (Number(formData["name"])) {
            formIsValid = false;
            errors["name"] = "Please enter a valid group name";

        } else if (formData["name"] < 1) {
            formIsValid = false;
            errors["name"] = "Please enter a valid group name";

        } else if (formData["name"].length > 150) {
            formIsValid = false;
            errors["name"] = "Group Name must not be greater than 150 character length";
        }

        if (!formData["email"] || !formData["email"].trim()) {
            formIsValid = false;
            errors["email"] = "Please enter email";

        } else if (!pattern.test(formData["email"])) {
            formIsValid = false;
            errors["email"] = "Please provide correct Email.";

        } else if (formData["email"] && !regEmail.test(formData["email"])) {
            formIsValid = false;
            errors["email"] = "The domain name should be muvi.com";
        }

        this.setState({ errors: errors });

        return formIsValid;

    }
    handleMemberValidation(group_type) {
        let formData = this.state.formData;
        let errors = {};
        let formIsValid = true;
        if (group_type == 1 || group_type == 2 || group_type == 4) {
            //            if (!formData["primary_members"] || formData["primary_members"] == "") {
            //                formIsValid = false;
            //                errors["primary_members"] = "Please choose a primary member";
            //            }
            //
            //            if (!formData["listener_members"] || formData["listener_members"] == "") {
            //                formIsValid = false;
            //                errors["listener_members"] = "Please choose a listener member";
            //            }
            if ((!formData["primary_members"] || formData["primary_members"] == "") && (!formData["listener_members"] || formData["listener_members"] == "")) {
                formIsValid = false;
                errors["listener_members"] = "Please Select Primary/ Listener Member";
            }
        } else if (group_type == 5) {
            if (!formData["selected_members"] || formData["selected_members"] == "") {
                formIsValid = false;
                errors["members"] = "Please choose a member";
            }

        } else if (group_type == 3) {
            if (!formData["selected_pod"] || formData["selected_pod"] == "") {
                formIsValid = false;
                errors["pod_includes"] = "Please choose a pod";
            }
        }

        this.setState({ errors: errors });

        return formIsValid;
    }

    EditGroup() {
        this.setState({ waiting: 'loading' });

        let errors = {};

        let is_valid = this.handleValidation();

        if (!is_valid) {
            this.setState({ waiting: '' });
            return false;
        }

        fetch(this.state.apiUrl + '/HrmanagementRest/UpdateGroups' + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: "POST",
            dataType: "json",
            body: JSON.stringify(this.state.formData),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {

                if (findresponse.code == 200) {

                    let copiedObject = JSON.parse(JSON.stringify(this.state.formData));
                    this.setState({
                        success_popup_msg: "Group has been updated successfully",
                        group_data: copiedObject,
                        waiting: ''
                    });
                    window.$("#quiz_Pass").modal('show');
                    if (this.timer) {
                        window.clearTimeout(this.timer);
                    }
                    this.timer = window.setTimeout(function () {
                        window.$("#quiz_Pass").modal('hide');
                    }, 1500);
                    this.GetGroupDetails(this.props.match.params.groupId);
                    this.logActivity(this.props.match.params.groupId);
                    this.toggleEdit();

                } else if (findresponse.code == 401) {

                    var status = findresponse.status;

                    errors[status] = findresponse.msg;

                    this.setState({ waiting: '', errors: errors });
                }

            }).catch(function (error) {

                console.log(error);

                this.setState({ waiting: '' });

            });

    }

    GetGroupDetails(groupId) {
        console.log(408, groupId);
        fetch(this.state.apiUrl + '/HrmanagementRest/GetGroupDetails' + '/id/' + this.state.userId + '/group_email/' + groupId + '/userAuthKey/' + this.state.userAuthKey, {
            method: "POST",
            dataType: "json",
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);

                console.log('response', findresponse);
                if (findresponse.data != null) {
                    var group_details = findresponse.data['group'] ? findresponse.data['group'] : {};

                    var group_data = findresponse.data['group_data'] ? findresponse.data['group_data'] : [];

                    this.setState({
                        formData: group_data,
                        group_details: group_details,
                        group_types: findresponse.group_types,
                        hr_permission: findresponse.hr_permission,
                        manager_permission: findresponse.manager_permission,
                        group_members: findresponse.group_members,
                        emailgroup_members: findresponse.emailgroup_members,
                        group_pods: findresponse.group_pods,
                    });

                    // let copiedObject = Object.assign({}, this.state.formData);
                    // console.log("hello",this.state.formData);

                    let copiedObject = JSON.parse(JSON.stringify(this.state.formData));
                    this.setState({
                        group_data: copiedObject,
                        //loading:0,
                    });
                } else {
                    window.location.href = '/groups/';
                }
            });
    }

    onChangeMember(type, e) {

        console.log(e);

        var memberData = this.state.memberData;

        var memberRestriction = this.state.memberRestriction;

        var errors = this.state.errors;

        if (type == 'primary_members') {

            let primary_members = [];

            e.forEach((element) => {
                primary_members.push(element.id);
            });

            memberData['selected_primary_members'] = e;

            memberData[type] = primary_members;

        } else if (type == 'listener_members') {

            let listener_members = [];

            e.forEach((element) => {
                listener_members.push(element.id);
            });

            memberData[type] = listener_members;

            memberData['selected_listener_members'] = e;

        } else if (type == 'members') {

            let members = [];

            e.forEach((element) => {
                members.push(element.id);
            });

            memberData['selected_members'] = e;

            memberData[type] = members;

        } else if (type == 'pod_includes') {

            let pod_includes = [];

            e.forEach((element) => {
                pod_includes.push(element.id);
            });

            memberData['selected_pod_includes'] = e;

            memberData[type] = pod_includes;

        } else {
            memberData[type] = e.target.value;
        }

        console.log(341, memberData);

        errors[type] = '';

        this.setState({
            memberData: memberData,
            errors: errors,
        });
    }

    showAddGroup() {
        this.setState({
            waiting: '',
            errors: {},
            success_message: '',
            selected_pod_list: [],
            selected_product_list: [],
            memberData: { 'listener_members': [], 'primary_members': [], 'members': [], 'pod_includes': [] }
        });
    }

    componentDidMount() {
        document.title = "Intranet | Groups";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.GetGroupDetails(this.props.match.params.groupId);
        this.logActivity(this.props.match.params.groupId);
    }

    logActivity(groupEmail) {
        fetch(this.state.apiUrl + '/HrmanagementRest/LogActivity' + '/id/' + this.state.userId + '/group_email/' + groupEmail + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: '',
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                console.log("new respose from actions", findresponse)
                if (findresponse) {
                    this.setState({ log_activity: findresponse.log_activity });
                }
            })
    }
    showTextLimit(e) {
        var maxLength = 500;
        var desctextlen = maxLength - e.target.value.length;
        this.setState({ desctextlen });
    }

    render() {

        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        const filterOptions = createFilterOptions({
            matchFrom: 'start',
            stringify: option => option.name,
        });
        console.log(565, this.state.log_activity)

        return (
            <div class="group">
                <Header brecum_name="Groups" brecum_page="Groups" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>{this.state.group_data && this.state.group_data['name']}</span>
                        </div>
                        {console.log(399, this.state.group_data)}
                        <div class="row mt20">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="all-btn-box">
                                    <div class="left-one">
                                        {/* <button type="submit" class="black-backbtn" onClick={() => this.ResetForm()}>Back</button> */}
                                        {console.log(380, this.state.hr_permission)}
                                        {this.state.hr_permission == 'yes' ?
                                            <button type="sumit" class="primaryadd-btn add-member-btn" title="Add Member" data-toggle="modal" data-target="#addMember" onClick={() => this.showAddGroup()} >{(this.state.group_data && this.state.group_data['group_type'] == 3) ? <span>Add POD</span> : <span>Add Member</span>}</button>
                                            : ""}
                                        {this.state.hr_permission == 'yes' ?
                                            <button className="primaryadd-btn delete-grp new" data-toggle="modal" data-target="#deletegroup" onClick={() => this.showDeleteModal(this.state.group_data['id'], this.state.group_data['name'], this.state.group_data['members'])} >Delete Group</button>
                                            : ""}
                                    </div>
                                    <div class="right-one">
                                        {this.state.is_editable ?
                                            <div>
                                                <button class="informDone" onClick={() => this.EditGroup(this.state.group_data['id'])}>
                                                    <span style={{ verticalAlign: 'unset' }}>
                                                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1.82568 5.07007L4.66943 7.91382L10.3569 1.82007" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        </svg>
                                                    </span>
                                                    Save
                                                </button>


                                                <button class="informCancel" onClick={() => this.toggleEdit()}>
                                                    <span>
                                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clipPath="url(#clip0_51_1927)">
                                                                <path d="M8.49992 14.6667C12.1818 14.6667 15.1666 11.6819 15.1666 8.00001C15.1666 4.31811 12.1818 1.33334 8.49992 1.33334C4.81802 1.33334 1.83325 4.31811 1.83325 8.00001C1.83325 11.6819 4.81802 14.6667 8.49992 14.6667Z" fill="#006EFA" stroke="#006EFA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                                                <path d="M10.5 6L6.5 10" stroke="#F2F2F2" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"></path>
                                                                <path d="M6.5 6L10.5 10" stroke="#F2F2F2" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"></path>
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_51_1927">
                                                                    <rect width="16" height="16" fill="white" transform="translate(0.5)"></rect>
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </span>
                                                    Cancel
                                                </button>
                                            </div>

                                            :
                                            this.state.hr_permission == 'yes' ?
                                                <button class="editprimary-btn" onClick={() => this.toggleEdit()}>
                                                    <span>
                                                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.65643 5.97988L5.08411 10.553C4.83885 10.798 4.53161 10.9719 4.19522 11.056L2.44118 11.4947C2.37696 11.5109 2.30964 11.5101 2.24581 11.4925C2.18197 11.4749 2.12379 11.441 2.07697 11.3942C2.03014 11.3473 1.99626 11.2892 1.97864 11.2253C1.96102 11.1615 1.96026 11.0942 1.97644 11.0299L2.41515 9.27666C2.4993 8.93992 2.67344 8.63239 2.91893 8.387L7.49047 3.81393L9.65643 5.97988ZM10.7398 2.7321C11.0269 3.01925 11.1881 3.40866 11.1881 3.81469C11.1881 4.22072 11.0269 4.61013 10.7398 4.89729L10.1977 5.43782L8.03177 3.27263L8.57383 2.7321C8.71603 2.58984 8.88486 2.477 9.07068 2.40001C9.2565 2.32301 9.45567 2.28339 9.65681 2.28339C9.85795 2.28339 10.0571 2.32301 10.2429 2.40001C10.4288 2.477 10.5976 2.58984 10.7398 2.7321V2.7321Z" fill="#006EFA"></path>
                                                        </svg>
                                                    </span>
                                                    Edit
                                                </button> : ""


                                        }

                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.state.errors["form"] ? <div class="row mt20">
                            <div class="col-xs-3 error">
                                {this.state.errors["form"]}
                            </div>
                        </div> : ''}


                        {this.state.is_editable ?

                            <div class="row mt15">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 group-cls-pd">
                                    <div class="podtop-box edit-podtop-box">
                                        <div class="top-one">
                                            <div className="input-box">
                                                <label class="input-label" for="name">Name<span class="star">*</span></label>
                                                <input type="text" class="input-cls" name="name" id="name" autoComplete="off" placeholder='Name' onChange={(e) => this.onChangeFrom('name', e)} value={this.state.formData['name']} />
                                                <div className="error name-err">{this.state.errors["name"]}</div>
                                            </div>
                                            <div className="input-box">
                                                <label class="input-label" for="group_type">Type<span class="star">*</span></label>
                                                <select class="form-control" id="group_type" name="group_type" disabled onChange={(e) => this.onChangeFrom('group_type', e)} value={this.state.formData['group_type']}>
                                                    {
                                                        this.state.group_types.map((dynamicData, key) =>
                                                            <option value={dynamicData.group_type} >{dynamicData.type_name}</option>
                                                        )
                                                    }
                                                </select>
                                                <span className="error">{this.state.errors["group_type"]}</span>
                                            </div>
                                            <div className="input-box mr0">
                                                <label class="input-label" for="email">Email<span class="star">*</span></label>
                                                <input type="text" class="input-cls disable" name="email" id="email" disabled placeholder='Email' autoComplete="off" onChange={(e) => this.onChangeFrom('email', e)} value={this.state.formData['email']} />
                                                <span className="error">{this.state.errors["email"]}</span>
                                            </div>
                                        </div>
                                        <div class="bottom-one pt15">
                                            <div className="textarea-box">
                                                <label class="textarea-label" for="description">Description</label>
                                                <textarea class="textarea-cls" name="description" id="description" maxlength="500" autoComplete="off" placeholder='Description' onKeyUp={(e) => this.showTextLimit(e)} onChange={(e) => this.onChangeFrom('description', e)} rows="5" value={this.state.formData['description']} style={{ resize: 'none' }}></textarea>
                                                <span class="desc-char-count">{this.state.desctextlen} / 500 </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            :

                            <div class="row mt15">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 group-cls-pd">
                                    <div class="podtop-box">
                                        <div class="top-one border-bottom pb15">
                                            <div class="top-text">Name :<span>{this.state.group_data && this.state.group_data['name']}</span></div>
                                            <div class="top-text">Group Type :<span>{this.state.group_data && this.state.group_data['type_name']}</span></div>
                                            <div class="top-text">Group Email ID :<span>{this.state.group_data && this.state.group_data['email']}</span></div>
                                            <div class="top-text">{(this.state.group_data && this.state.group_data['group_type'] == 3) ? "Pods" : (this.state.group_data['group_type'] == 5) ? "Members" : "Primary Members"} :<span>{this.state.group_data && this.state.group_data['members']}</span></div>
                                        </div>
                                        <div class="bottom-one pt15">
                                            <div class="bottom-title">Description</div>
                                            <div class="bottom-description">{this.state.group_data && this.state.group_data['description'] ? this.state.group_data['description'] : "N/A"}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        }

                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                {this.state.formData['group_type'] == 3 ?
                                    <Troops parent={this} userId={this.state.userId} userAuthKey={this.state.userAuthKey} group={this.state.group_details} group_data={this.state.group_data} hr_permission={this.state.hr_permission} group_type={this.state.formData['group_type']} groupId={this.props.match.params.groupId} />
                                    :
                                    (this.state.formData['group_type'] == 1 || this.state.formData['group_type'] == 5) ?
                                        <DeptMembers parent={this} group_type={this.state.formData['group_type']} group_data={this.state.group_data} group_members={this.state.group_details} hr_permission={this.state.hr_permission} />
                                        :
                                        <GroupMembers parent={this} group_type={this.state.formData['group_type']} group_data={this.state.group_data} group_members={this.state.group_details} hr_permission={this.state.hr_permission} />}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="group-history">
                                    <h5 class="title">History</h5>
                                    <ul class="tickets_head">
                                        <li class="intra_col_25">Date</li>
                                        <li class="intra_col_25">Field</li>
                                        <li class="intra_col_25">Changes</li>
                                        <li class="intra_col_25">Action By</li>
                                    </ul>

                                    {(this.state.log_activity.length == 0) ? <div className="text-center" style={{ color: '#888' }}>No Data Found</div> :
                                        this.state.log_activity.map((log, key) =>
                                            <ul class="tickets_number">
                                                <li class="intra_col_25">
                                                    <div>{log.datemodified}</div>
                                                </li>
                                                <li class="intra_col_25">
                                                    <div>{log.field ? log.field : '--'}</div>
                                                </li>
                                                <li class="intra_col_25">
                                                    <div>{log.action == 1 && log.updated_changes ?
                                                        log.group_type == 3 ? "POD Added => " :
                                                            "Member Added => " : ""
                                                    }{log.updated_changes}
                                                    </div>
                                                </li>
                                                <li class="intra_col_25">
                                                    <div>{log.action_by ? log.name : '--'}</div>
                                                </li>
                                            </ul>
                                        )
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="add_popup">
                    <div class="modal fade" id="addMember" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 5L5 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M5 5L15 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </button>
                                    <h4 class="modal-title">Add {(this.state.group_data && this.state.group_data['group_type'] == 3) ? <span>POD</span> : <span>Member</span>}</h4>
                                </div>
                                <div class="modal-body">
                                    <div className='row mt15'>
                                        {(this.state.formData['group_type'] == 1) || (this.state.formData['group_type'] == 2) || (this.state.formData['group_type'] == 4) ?
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label class="tag-newlabel" for="primary_members">Primary</label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.group_members}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeMember('primary_members', value)
                                                        }
                                                        getOptionDisabled={(option) => !!this.state.memberData['listener_members'].find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="Primary Members"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["primary_members"]}</span>
                                                </div>
                                            </div>
                                            : ""}

                                        {this.state.formData['group_type'] == 5 ?
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label class="tag-newlabel" for="members">Members<span class="star">*</span></label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.emailgroup_members}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeMember('members', value)
                                                        }
                                                        // onChange={(event , value) => this.handlePrimaryChange(value)}
                                                        // getOptionDisabled={(option) => !! this.state.defaultList.find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="Members"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["members"]}</span>
                                                </div>
                                            </div>

                                            : ""}
                                        {console.log(714, this.state.group_pods)}
                                        {this.state.formData['group_type'] == 3 ?
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label class="tag-newlabel" for="pod_includes">Includes<span class="star">*</span></label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.group_pods}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeMember('pod_includes', value)
                                                        }
                                                        // onChange={(event , value) => this.handlePrimaryChange(value)}
                                                        // getOptionDisabled={(option) => !! this.state.defaultList.find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="POD"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["pod_includes"]}</span>
                                                </div>
                                            </div>
                                            : ""}

                                        {(this.state.formData['group_type'] == 1) || (this.state.formData['group_type'] == 2) || (this.state.formData['group_type'] == 4) ?
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label class="tag-newlabel" for="listener_members">Listener</label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.group_members}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeMember('listener_members', value)
                                                        }
                                                        getOptionDisabled={(option) => !!this.state.memberData['primary_members'].find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="Listener Members"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["listener_members"]}</span>
                                                </div>
                                            </div>
                                            : ""}
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span style={{ float: 'left', color: 'red' }}>{this.state.errors["form"]}</span>
                                            {this.state.success_message ? <span style={{ float: 'left', color: 'green' }}>{this.state.success_message}</span> : ''}
                                            <div class="all-boxbtn">
                                                <button type="button" class="dissmiss-btn" data-dismiss="modal">Dismiss</button>
                                                {this.state.waiting ?
                                                    <button type="submit" className="adds-btn disabled" ><div><i className="fa fa-spinner fa-spin"></i><span> Wait</span></div></button>
                                                    :
                                                    this.state.formData['group_type'] == 3 ?
                                                        <button type="submit" className="adds-btn" onClick={() => this.AddPod()} >Add</button>
                                                        :
                                                        this.state.formData['group_type'] == 5 ?
                                                            <button type="submit" className="adds-btn" onClick={() => this.AddMember()} >Add</button>
                                                            :
                                                            (this.state.formData['group_type'] == 1) || (this.state.formData['group_type'] == 2) || (this.state.formData['group_type'] == 4) ?
                                                                <button type="submit" className="adds-btn" onClick={() => this.AddPrimarynListenerMember()} >Add</button>
                                                                : ''
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="editLink_popup">
                    <div className="modal fade" id="quiz_Pass" tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h2 className="modal-title text-center">Success</h2>
                                </div>
                                <div className="modal-body">
                                    <div className="icon_txt">
                                        <i className="fal fa-check-circle"></i>
                                        <span>{this.state.success_popup_msg}</span>
                                    </div>
                                    <p className="text-center mt20">
                                        <button className="btn btn block" data-dismiss="modal">Close</button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="editLink_popup">
                    <div className="modal fade" id="deletegroup" tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="icon_txt">
                                        Are you sure to delete group  <b>{this.state.deleteGroupData.grp_name}</b> with <b>{this.state.deleteGroupData.member_cnt}</b> members?
                                    </div>
                                    <p className="mt20 pull-right">
                                        <button className="btn btn-blue" data-dismiss="modal">Cancel</button>
                                        <button type="button" class="btn btn-sky" onClick={() => this.deleteGroup(this.state.deleteGroupData.group_id, this.state.deleteGroupData.grp_name, this.state.deleteGroupData.member_cnt)}>Delete</button>
                                    </p>
                                    <div class="clear"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="editLink_popup">
                    <div className="modal fade" id="deleteEmployee" tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="icon_txt">
                                        {this.state.removeConfirmMsg}
                                    </div>
                                    <p className="mt20 pull-right">
                                        <button className="btn btn-blue" data-dismiss="modal">Cancel</button>
                                        <button type="button" class="btn btn-sky" onClick={() => this.removeEmployeeFromGroup(this.state.deleteEmpData.group_id, this.state.deleteEmpData.is_primary, this.state.deleteEmpData.member_id, this.state.deleteEmpData.group_type)}>Remove</button>
                                    </p>
                                    <div class="clear"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default GroupDetail;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/GroupDetail.js